'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var canonical = require('@circlefin/canonical');

/**
 * Default money options.
 */ const defaultMoneyOptions = {
    symbol: true,
    padded: true,
    signDisplay: false,
    condensed: false
};

Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function () { return canonical.currencyVariants; }
});
Object.defineProperty(exports, "variants", {
    enumerable: true,
    get: function () { return canonical.currencyVariants; }
});
exports.defaultMoneyOptions = defaultMoneyOptions;
//# sourceMappingURL=index.js.map
